import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { NationalDataConfig } from "./national-data.config";
import { BirthCountry, BirthProvince, CountryWithCities } from "./national-data.model";

/**
 * @deprecated [fabric-deprecated] - use NationalDataService from app-account instead
 */
@Injectable({
	providedIn: "root",
})
export class NationalDataService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: NationalDataConfig
	) {}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetBirthProvincesNationalData) instead
	 */
	getBirthProvinces(): Observable<BirthProvince[]> {
		return this.httpClient.get<BirthProvince[]>({ url: this.config.getBirthProvincesEndpoint() });
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetCountryCitiesNationalData) instead
	 */
	getCountryCities(): Observable<CountryWithCities> {
		return this.httpClient.get<CountryWithCities>({ url: this.config.getCountryCitiesEndpoint() }).pipe(
			tap((countryWithCities) => {
				if (this.config.getAddStateCodeToCities()) {
					countryWithCities.cities.forEach((city) => {
						city.name = `${city.name} (${city.stateCode})`;
					});
				}
			})
		);
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetCountryByTaxCodeNationalData) instead
	 */
	getCountryByTaxCode(taxCodeFragment: string): Observable<BirthCountry> {
		return this.httpClient.get<BirthCountry>({
			url: `${this.config.getCountryByTaxCodeEndpoint()}${taxCodeFragment}`,
		});
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetTaxCodeByCountryNationalData) instead
	 */
	getTaxCodeByCountry(countryCode: string): Observable<BirthCountry> {
		return this.httpClient.get<BirthCountry>({
			url: `${this.config.getTaxCodeByCountryEndpoint()}${countryCode}`,
		});
	}
}
